import FeatureSwitch from "./FeatureSwitch";

export default FeatureSwitch;
